import { action } from '@storybook/addon-actions';
import { Meta, StoryObj } from '@storybook/react';

import { Button } from 'components/parts/Button';

import { Dialog } from './Dialog';

const meta: Meta<typeof Dialog> = {
  title: 'parts/Dialog',
  component: Dialog,
  args: {
    isOpen: true,
    easyCloseMode: true,
    addClass: [],
    handleClose: action('close'),
    children: (
      <>
        <p>ダイアログです</p>
        <Button text="OK" handleClick={action('close')} />
      </>
    ),
  },
};

export default meta;

type Story = StoryObj<typeof Dialog>;

export const Basic: Story = {
  render: args => <Dialog {...args} />,
};
